import * as UI from "@accurx/design";
import styled from "styled-components";

const { Ds } = UI;

export const StyledForm = styled.form`
    height: 100%;
`;

export const FormWrapper = styled(Ds.Flex)`
    padding: 0.75rem;
    background-color: var(--ds-color-orange-5);
    width: 100%;
    height: 100%;
    border-radius: var(--ds-border-radius);
    border: 1px solid var(--ds-color-silver);

    /* 'Tokens.SHADOWS.floating.high' doesn't work in the embedded view, so this is hard-coded for now. */
    box-shadow: 0px 4px 16px 0px #44487e52;
`;

export const IconWrapper = styled.div`
    margin-left: -0.25rem;
    margin-right: 0.25rem;
`;

export const TextAreaWrapper = styled.div`
    border-radius: var(--ds-border-radius);
    border: 1px solid transparent;
    flex: 1 1 min-content;
    overflow-y: auto;
    max-height: 100%;
    height: 100%;

    &:hover {
        ${UI.hoverBorderStyles}
    }

    &:focus-within {
        ${UI.focusBorderStyles}
    }

    & > div {
        border: none;
        height: 100%;
    }
`;

export const StyledTextArea = styled(Ds.Textarea)`
    line-height: 1.5rem;
    font-size: 0.875rem;
    width: 100%;
    border: none;
    background-color: var(--ds-color-orange-5);

    &:hover {
        border: none;
    }

    &:focus {
        box-shadow: none;
        border: none;
        outline: none;
    }
`;
